import React from 'react';
import { FormGroup, Label, Input, Button } from 'reactstrap';
import { IconPlus, IconTrash } from '@tabler/icons-react';

const ProjectPageTab = ({ projectPage = {}, updateLocalProjectPageConfig }) => {
    const { contestantAnswerHeaders = [] } = projectPage;

    const handleHeaderChange = (index, value) => {
        const newHeaders = [...contestantAnswerHeaders];
        newHeaders[index] = value;
        updateLocalProjectPageConfig({ contestantAnswerHeaders: newHeaders });
    };

    const handleAddHeader = () => {
        if (contestantAnswerHeaders.length < 5) {
            const newHeaders = [...contestantAnswerHeaders, ''];
            updateLocalProjectPageConfig({ contestantAnswerHeaders: newHeaders });
        }
    };

    const handleRemoveHeader = (index) => {
        const newHeaders = contestantAnswerHeaders.filter((_, i) => i !== index);
        updateLocalProjectPageConfig({ contestantAnswerHeaders: newHeaders });
    };

    return (
        <div>
            <div className="mb-4">
                <h2 className="h6 text-uppercase text-muted fw-bold border-bottom pb-2 mb-3">
                    Antworten auf der Projektseite
                </h2>
                <p className="text-muted small mb-3">
                    Konfigurieren Sie die Überschriften/Fragen für die Antworten der Teilnehmer auf der
                    Projektdetailseite (maximal 5).
                </p>

                {contestantAnswerHeaders.map((header, index) => (
                    <FormGroup key={index} className="mb-3 border p-2 rounded bg-white shadow-sm">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                            <Label className="fw-bold mb-0" style={{ fontSize: '0.85rem' }}>
                                Überschrift {index + 1} (Antworten: <code>contestantAnswer{index + 1}</code>)
                            </Label>
                            <Button
                                size="sm"
                                color="danger"
                                outline
                                className="border-0 p-1"
                                onClick={() => handleRemoveHeader(index)}
                                title="Überschrift entfernen"
                            >
                                <IconTrash size={16} />
                            </Button>
                        </div>
                        <Input
                            type="text"
                            value={header}
                            placeholder={`Text für Überschrift ${index + 1}`}
                            onChange={(e) => handleHeaderChange(index, e.target.value)}
                        />
                    </FormGroup>
                ))}

                {contestantAnswerHeaders.length < 5 && (
                    <Button
                        color="primary"
                        outline
                        className="d-flex align-items-center justify-content-center w-100 py-2"
                        onClick={handleAddHeader}
                    >
                        <IconPlus size={18} className="me-1" /> Überschrift hinzufügen (
                        {5 - contestantAnswerHeaders.length} verbleibend)
                    </Button>
                )}
            </div>
        </div>
    );
};

export default ProjectPageTab;
